import { color, shadow, spacing, Typography } from '@uniquegood/realworld-studio-design';
import React from 'react';
import { css } from '@emotion/react';
import { onMobile } from '@styles/responsive';
import { KeyboardFocusStyle } from '@/styles';
import NewGameIcon from '@/pages/home/assets/new-game.svg';

interface ProjectItemProps {
  onClick: (e: React.MouseEvent) => void;
}

function CreateProject({ onClick }: ProjectItemProps) {
  return (
    <button
      type="button"
      css={[LinkTagStyle, MakeGameContainerStyle, AspectRatio, KeyboardFocusStyle]}
      onClick={(e) => {
        onClick(e);
      }}
    >
      <img src={NewGameIcon} alt="새 게임" css={IconGamePadStyle} />
      <Typography as="p" type="button" textColor="subdued">
        새 콘텐츠 만들기
      </Typography>
    </button>
  );
}

export default CreateProject;

const LinkTagStyle = css`
  display: block;

  ${onMobile} {
    width: 100%;
    height: 140px;
  }
`;

const MakeGameContainerStyle = css`
  border-radius: ${spacing.borderRadius.xlarge};
  border: 1px solid ${color.border_default_subdued};
  background-color: ${color.surface_default_default};
  ${shadow.card};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const AspectRatio = css`
  aspect-ratio: 310/340;
`;

const IconGamePadStyle = css`
  width: 152px;
  height: 152px;
  margin: 0px;

  ${onMobile} {
    width: 56px;
    height: auto;
  }
`;
